import { motion, useReducedMotion } from "framer-motion";
import { Overline, Reveal } from "./Reveal";
import { SiteBuilder } from "./SiteBuilder";

const STAGES = [
  { id: "presenca", label: "Presença Digital" },
  { id: "aquisicao", label: "Aquisição de Visitantes" },
  { id: "mensuracao", label: "Mensuração" },
  { id: "otimizacao", label: "Otimização" },
  { id: "crescimento", label: "Crescimento" },
];

export const ImpactFlow = () => {
  const reduce = useReducedMotion();
  return (
    <section id="impacto" data-testid="impact-section" className="relative overflow-hidden border-y border-white/5 bg-gb-ink/40 py-24 lg:py-32">
      <div aria-hidden="true" className="absolute left-1/2 top-0 h-[420px] w-[820px] -translate-x-1/2 rounded-full bg-[radial-gradient(ellipse,rgba(199,205,214,0.06),transparent_65%)] blur-2xl" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-12">
        <Reveal>
          <Overline>Resultados e métricas</Overline>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="mt-6 max-w-3xl font-display text-2xl font-bold leading-tight tracking-tight sm:text-3xl lg:text-4xl">
            Não basta atrair visitantes.{" "}
            <span className="chrome-text">É preciso entender o que gera oportunidades.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.18}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-gb-gray sm:text-lg">
            Conectamos sua presença digital, suas campanhas e seus dados para que as decisões sejam
            tomadas com mais clareza e estratégia.
          </p>
        </Reveal>

        <div className="relative mt-20">
          <div aria-hidden="true" className="chrome-line absolute left-0 right-0 top-5 hidden h-px lg:block" />
          {!reduce && (
            <motion.span
              aria-hidden="true"
              className="absolute top-5 hidden h-1.5 w-1.5 -translate-y-1/4 rounded-full bg-gb-silverhi shadow-[0_0_14px_rgba(239,243,248,0.8)] lg:block"
              animate={{ left: ["0%", "100%"] }}
              transition={{ duration: 7, repeat: Infinity, ease: "linear" }}
            />
          )}
          <ol className="grid gap-10 sm:grid-cols-2 lg:grid-cols-5 lg:gap-6">
            {STAGES.map((stage, i) => (
              <Reveal key={stage.id} delay={0.1 * i}>
                <li data-testid={`impact-flow-node-${i}`} className="group relative">
                  <div className="relative z-10 flex h-10 w-10 items-center justify-center rounded-full border border-gb-silver/30 bg-gb-black font-mono text-xs text-gb-silver transition-colors duration-500 group-hover:border-gb-silverhi group-hover:text-gb-silverhi">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <p className="mt-5 font-display text-sm font-bold uppercase tracking-[0.14em] text-gb-white">
                    {stage.label}
                  </p>
                  <span aria-hidden="true" className="mt-3 block h-px w-10 bg-gb-silver/25 transition-all duration-500 group-hover:w-16 group-hover:bg-gb-silver/70" />
                </li>
              </Reveal>
            ))}
          </ol>
        </div>
        <Reveal delay={0.25}>
          <div className="mt-20 flex flex-col items-center">
            <SiteBuilder startDelay={0.2} />
            <p className="mt-8 font-mono text-[10px] uppercase tracking-[0.25em] text-gb-gray/70">
              Assim nasce um site GOBAX — montado na sua frente
            </p>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-14 font-mono text-[10px] uppercase tracking-[0.25em] text-gb-gray/70">
            Fluxo ilustrativo do método GOBAX — demonstração visual, sem dados de clientes
          </p>
        </Reveal>
      </div>
    </section>
  );
};
